import Fuzzy from "@leeoniya/ufuzzy"

import { exists } from "./exists"

export function fuzzySearch<T>(
  items: T[],
  searchTerm: string,
  getSearchableString: (item: T) => string,
  fuzzy: Fuzzy
) {
  const haystack = items.map(item => getSearchableString(item))

  const [matches, , order] = fuzzy.search(haystack, searchTerm)

  const result: T[] = []

  if (!order || !matches) {
    return []
  }

  for (let i = 0; i < (matches?.length || 0); i += 1) {
    if (exists(order[i]) && exists(matches[i])) {
      result[order[i]] = items[matches[i]]
    }
  }

  return result
}
